let staticToken = "";
let getToken = function() {
  let token = localStorage.getItem("loginToken");
  // console.log("token",token)
  // //如果页面不带token,会返回undefined,如果是undefined,null,空,取之前保存的
  // if (typeof token == "undefined" || (!token && token != 0) || token == "") {
  //   window.localStorage.setItem("loginToken", "");
  // //   // 判断js里面存储的和浏览器保存的是否相同,不同的话,以浏览器存储的为准
  //   if (staticToken != window.localStorage.getItem("loginToken")) {
  //     staticToken = window.localStorage.getItem("loginToken");
  //   }
  //   return staticToken;
  // } else {
  //   staticToken = token;
  //   window.localStorage.setItem("loginToken", token);
    return token;
  // }
};

// let getToken = function() {
//   let stoken = window.localStorage.getItem("loginToken");
//   return stoken;

// }
//动态获取主机名,根据选择的线路来请求不同线路的服务
let fnhost = function() {
  let local_hostname = location.hostname;
  let port=location.port;
  let returnURL = "http://" + local_hostname + ":28920";
  // return "http://172.18.0.242:8120";
  return "http://" + location.host+"/";
};
export let baseToken = getToken();
//发布时候用这个
//export const baseURL = fnhost();
//调试用这个
//  export const baseURL = 'http://172.18.0.242:15313/';

let prefix;
if (process.env.NODE_ENV === "development") {
  prefix = "http://localhost:28920/";
} else {
  prefix = fnhost();
}
export let baseURL = prefix;
